import {
  CalendarEventWriteResult,
  ProposeCalendarEventTimeInput,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type ProposeExternalCalendarEventTimeOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: ProposeCalendarEventTimeInput;
};

// The callable this binds to is not deployed yet — the propose-new-time control is built
// against the agreed name and errors until the backend ships it. Confirm before release.
export const proposeExternalCalendarEventTime = async <TFunctions>(
  options: ProposeExternalCalendarEventTimeOptions<TFunctions>,
): Promise<CalendarEventWriteResult> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    ProposeCalendarEventTimeInput,
    CalendarEventWriteResult
  >(functions, 'externalCalendars-proposeNewTime');

  const { data } = await callable(payload);

  return data;
};
